<script setup lang="ts">
    import { columns } from '@/tables/columns/kube';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateKube from '@/components/kube/CreateKube.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import SystemCardMenu from '@/components/system/SystemCardMenu.vue';
    import type { BreadcrumbItem } from '@/types';

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.system',
            href: route('v2.vat-deadlines.index'),
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.KUBE],
        queryFn: getKube,
    });

    async function getKube() {
        const { data } = await axios.get(route('v2.kube.table'));
        return data.data;
    }
</script>

<template>
    <Head :title="$t('kube.page_header')" />

    <AppLayout :breadcrumbs="breadcrumbs">
        <PageCard>
            <DataTable
                :table-key="QueryKey.KUBE"
                :columns="columns"
                :data="data"
                :loading="isPending"
                :default-sorting="[
                    {
                        id: 'name',
                        desc: false,
                    },
                ]"
            >
                <template #title>
                    <SystemCardMenu />
                </template>
                <template #actions>
                    <DataTableToolbarActions name="kube">
                        <CreateKube v-if="hasPermission(Permission.SYSTEM_CREATE)" />
                    </DataTableToolbarActions>
                </template>
            </DataTable>
        </PageCard>
    </AppLayout>
</template>
